module.exports = __webpack_public_path__ + "img/b44ded117083ac54950d674b9d17a244.png";